var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"Headset\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.78195 10.5971C9.78195 9.69687 9.05187 8.96679 8.15163 8.96679H7.33646C5.53546 8.96679 4.07581 10.4264 4.07581 12.2274V14.6729C4.07581 16.4739 5.53546 17.9336 7.33646 17.9336H8.15163C9.05187 17.9336 9.78195 17.2035 9.78195 16.3033V10.5971ZM18.7487 17.9336C20.5497 17.9336 22.0094 16.4739 22.0094 14.6729V12.2274C22.0094 10.4264 20.5497 8.96679 18.7487 8.96679H17.9336C17.0333 8.96679 16.3033 9.69687 16.3033 10.5971V16.3033C16.3033 17.2035 17.0333 17.9336 17.9336 17.9336H18.7487ZM13.0426 0C5.76626 0 0.23334 6.05411 0 13.0426V13.8578C0 14.3081 0.364785 14.6729 0.815163 14.6729H1.63033C2.0807 14.6729 2.44549 14.3081 2.44549 13.8578V13.0426C2.44549 7.19941 7.19941 2.44549 13.0426 2.44549C18.8858 2.44549 23.6397 7.19941 23.6397 13.0426H23.6336C23.6377 13.1664 23.6397 21.4856 23.6397 21.4856C23.6397 22.6753 22.6753 23.6397 21.4856 23.6397H16.3033C16.3033 22.2891 15.2084 21.1942 13.8578 21.1942H12.2274C10.8768 21.1942 9.78195 22.2891 9.78195 23.6397C9.78195 24.9903 10.8768 26.0852 12.2274 26.0852H21.4856C24.0259 26.0852 26.0852 24.0259 26.0852 21.4856V13.0426C25.8519 6.05411 20.3189 0 13.0426 0Z",
    fill: "#7B7B7B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadset);
export default __webpack_public_path__ + "static/media/headset.a5f182a8c3a9f890b88fd7cfdc32767d.svg";
export { ForwardRef as ReactComponent };